import { type FC, type ReactNode } from "react";

import cameraKitIcon from "../../../assets/common/camera-kit-icon.svg";

import { Image } from "../../components/Image";
import { StyledContainer, StyledCentered } from "./ContainerWithCamkitIcon.styles";

interface ContainerWithCamkitIconProps {
    children: ReactNode;
}

export const ContainerWithCamkitIcon: FC<ContainerWithCamkitIconProps> = ({ children }) => {
    return (
        <StyledContainer>
            <StyledCentered>
                <Image src={cameraKitIcon} alt="camera kit" widthPx={40} heightPx={40} />
                {children}
            </StyledCentered>
        </StyledContainer>
    );
};
